import { render, staticRenderFns } from "./PatrimonyList.vue?vue&type=template&id=33511e6f&scoped=true&"
import script from "./PatrimonyList.vue?vue&type=script&lang=js&"
export * from "./PatrimonyList.vue?vue&type=script&lang=js&"
import style0 from "./PatrimonyList.vue?vue&type=style&index=0&id=33511e6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33511e6f",
  null
  
)

export default component.exports